//BFSG
import { Order } from 'hooks/account/types'
import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import InfoLine from './InfoLine'
import MoreIndicatorDesktop from './MoreIndicatorDesktop'
import OrderButton from './OrderButton'
import Product from './Product'
import useOrderProducts from './useOrderProducts'
import { Icon } from 'theme/atoms/Button'

type Props = {
  sw6Uuids: string[]
  order?: Order
  title?: string
  actionButtonLabel: string
  actionButtonLink: string
  actionButtonIcon?: Icon
  actionButtonAriaLabel: string
}

export default function MiniCart(props: Props) {
  const products = useOrderProducts(props.sw6Uuids)
  // calculate if the order is older than 24 hours
  const orderDate = props.order?.createdAt || ''
  const diff = new Date().valueOf() - new Date(orderDate).valueOf()
  const twentyFourHours = 86400000
  const orderIsNotOlderThan24Hours = diff < twentyFourHours
  /** we show a maximum of 4 products. when we have more we show a "more" flag */
  const showExpandPlaceholder = products.length > 4
  const displayItems = showExpandPlaceholder ? products.slice(0, 3) : products
  const totalItems = products.length

  return (
    <Wrapper className="OrderItem" data-cy-ctx="molecules/account/MiniCart">
      {props.title && <h3 data-cy-state="has-title">{props.title}</h3>}
      {props.order && (
        <InfoLine
          order={props.order}
          data-cy-state="has-order"
          orderNotOlderThan24Hours={orderIsNotOlderThan24Hours}
        />
      )}
      <div className="products">
        {displayItems.map((item) => (
          <Product key={item.sw6Uuid} product={item} />
        ))}
        {showExpandPlaceholder && (
          <MoreIndicatorDesktop
            data-cy-state="show-expanded"
            totalItems={totalItems}
          />
        )}
      </div>
      <OrderButton
        order={props.order}
        totalItems={totalItems}
        label={props.actionButtonLabel}
        aria-label={props.actionButtonAriaLabel}
        link={props.actionButtonLink}
        icon={props.actionButtonIcon}
        orderNotOlderThan24Hours={orderIsNotOlderThan24Hours}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: relative;
  background: ${theme.colors.shade.b7};
  padding: ${theme.spacing('m')};

  > h3 {
    ${theme.ty('rc-2xl', 'bold', 'rc-3xl')}
    margin-bottom: ${theme.spacing('m')};
  }

  > .InfoLine {
    margin-bottom: ${theme.spacing('m')};
    @media (min-width: ${theme.ms.MD}px) {
      margin-bottom: ${theme.spacing('l')};
    }
  }

  > .products {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: ${theme.spacing('m')};
    margin-bottom: ${theme.spacing('m')};
    @media (min-width: ${theme.ms.MD}px) {
      grid-template-columns: 1fr 1fr;
    }
  }
`
